import React from 'react';
import { motion } from 'framer-motion';
const fade = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5
  }
};
export function Narrative() {
  return <section className="py-16 md:py-24 px-4 pt-[10px] pb-[10px]" data-id="element-147">
      <div className="max-w-2xl mx-auto" data-id="element-148">
        {/* Opening question — serif, big */}
        <motion.h2 {...fade} className="font-serif text-2xl md:text-3xl text-brown-900 font-bold leading-snug mb-8 text-center" data-id="element-149">
          ¿Por qué hay personas a las que parece salirles todo —éxito, dinero,
          relaciones, un físico increíble, salud— que fluyen, que tienen suerte
          y a quienes todo les coopera a su favor siempre?
        </motion.h2>

        <div className="space-y-6 font-sans text-base md:text-lg text-brown/90 leading-relaxed" data-id="element-150">
          <motion.p {...fade} data-id="element-151">
            Te sorprenderías si supieras que todo eso{' '}
            <strong className="text-brown-900" data-id="element-152">nace de un estado mental</strong>
            . Esas personas no tienen nada distinto: simplemente aprendieron a
            gobernar su propia mente y a ponerla a trabajar a su favor, todo el
            tiempo y casi sin esfuerzo. Van en piloto automático, y por eso
            encadenan un resultado tras otro.{' '}
            <strong className="text-brown-900" data-id="element-153">
              Lo bueno es que no tienen nada que vos no tengas: solo saben qué
              usar y cómo usarlo.
            </strong>
          </motion.p>

          <motion.p {...fade} data-id="element-154">
            La clave no está en un esfuerzo con un desgaste mental y físico
            enorme, como cree la mayoría. Es mucho más simple: se trata de
            instalar un nuevo sistema que haga que tu mente cambie lo que hace
            con todo eso que no te gusta y quisieras cambiar. Y de eso se
            encarga Hackeá tu Realidad.
          </motion.p>

          <motion.p {...fade} className="font-serif text-xl md:text-2xl text-gold font-bold italic text-center py-4" data-id="element-155">
            La mayoría nunca lo logra, no por incapacidad, sino porque nunca le
            explicaron cómo se hace.
          </motion.p>

          <motion.p {...fade} className="text-center text-brown-900 text-[19px] font-[700] font-sans" data-id="element-156">
            Hoy puede ser ese día que lo cambie todo.
          </motion.p>

          <motion.p {...fade} data-id="element-157">
            Las palabras que te decís a vos mismo tienen más fuerza de la que
            imaginás.{' '}
            <strong className="text-brown-900" data-id="element-158">Hackeá tu Realidad</strong>{' '}
            reescribe tu diálogo interno y desactiva el autosabotaje que te
            desconecta de esa versión tuya que sí puede. Y desde el día uno,
            empezás a notar los cambios.
          </motion.p>

          <motion.p {...fade} className="font-serif text-lg md:text-xl text-brown-900 font-bold text-center py-2" data-id="element-159">
            Eso es Hackeá tu Realidad: el secreto que muy pocos conocen. Y desde
            hoy, puede ser tuyo.
          </motion.p>

          <motion.p {...fade} data-id="element-160">
            Hoy queda en vos. Podés seguir como hasta ahora —que posiblemente
            sea tu caso—, cargando con todo eso que no te gusta y mirando de
            afuera a los que parece que todo les sale bien «por suerte», los que
            tienen esa vida de éxito o resultados que sentís que ni siquiera son
            para vos. O podés darte la oportunidad de instalar una nueva forma
            de pensar, hacer que las cosas empiecen a obrar a tu favor y
            convertirte en una más de esas personas que sobresalen de la media.
          </motion.p>

          <motion.p {...fade} className="font-serif text-xl md:text-2xl font-bold italic text-center py-4 text-[#000000] pt-[1px] pb-[1px]" data-id="element-161">
            Porque eso que muchos llaman suerte no es suerte ni magia: es una
            mente con el código correcto —las palabras justas— que sabe
            exactamente cómo ejecutarlo para que todo termine obrando a su
            favor, incluso en las situaciones más complicadas.
          </motion.p>
        </div>
      </div>
    </section>;
}